module.exports = __webpack_public_path__ + "media/applicants/google-play-230c0c4d.png";